/** User-friendly copy for linking social accounts (non-developer). */
export const PLATFORM_CONNECT = [
  {
    id: "tiktok",
    label: "TikTok",
    emoji: "🎵",
    color: "#010101",
    tagline: "Post scheduled videos to TikTok",
    fieldLabel: "Paste your TikTok connection token",
    fieldPlaceholder: "Paste the token your TikTok app gave you…",
    steps: [
      "Open TikTok for Developers and sign in with the account you want to post from.",
      "Create or open your app, then complete login / authorization for that account.",
      "Copy the access token and paste it below — one paste links your account.",
    ],
    helpUrl: "https://developers.tiktok.com/doc/login-kit-web",
    helpLinkText: "TikTok developer help",
  },
  {
    id: "instagram",
    label: "Instagram",
    emoji: "📸",
    color: "#C13584",
    tagline: "Share reels and posts to Instagram",
    fieldLabel: "Paste your Instagram connection token",
    fieldPlaceholder: "Paste your Meta / Instagram token here…",
    steps: [
      "Use a Business or Creator Instagram account (personal-only accounts may not work).",
      "Sign in at Meta for Developers or Business Suite with the Instagram you want to use.",
      "Copy the access token for that account and paste it below.",
    ],
    helpUrl: "https://business.facebook.com/",
    helpLinkText: "Open Meta Business Suite",
  },
  {
    id: "facebook",
    label: "Facebook",
    emoji: "👍",
    color: "#1877F2",
    tagline: "Publish to your Facebook Page",
    fieldLabel: "Paste your Facebook connection token",
    fieldPlaceholder: "Paste your Facebook Page token here…",
    steps: [
      "Sign in to Facebook with the profile that manages your Page.",
      "In Meta for Developers or Business Suite, get a token for your Facebook Page.",
      "Paste that token below — we will detect your Page automatically.",
    ],
    helpUrl: "https://business.facebook.com/",
    helpLinkText: "Open Meta Business Suite",
  },
  {
    id: "youtube",
    label: "YouTube Shorts",
    emoji: "▶️",
    color: "#FF0000",
    tagline: "Upload Shorts to your YouTube channel",
    fieldLabel: "Paste your YouTube connection token",
    fieldPlaceholder: "Paste your Google / YouTube token here…",
    steps: [
      "Sign in with the Google account that owns your YouTube channel.",
      "Complete Google authorization for YouTube upload access.",
      "Copy the access token and paste it below.",
    ],
    helpUrl: "https://console.cloud.google.com/apis/credentials",
    helpLinkText: "Google Cloud credentials",
  },
];
